import React from 'react'

export const StudentsIcon = ({ color = '#182358', ...rest }) => (
  <svg
    {...rest}
    width="32"
    height="26"
    viewBox="0 0 32 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9974 10.9755C13.9974 13.9825 11.5531 16.4269 8.54792 16.4269C5.54282 16.4269 3.09839 13.9826 3.09839 10.9774C3.09839 7.97035 5.54272 5.52592 8.54792 5.52592C11.553 5.52592 13.9974 7.97026 13.9974 10.9755ZM11.7052 10.9771C11.7052 9.23593 10.2891 7.8198 8.54792 7.8198C6.80678 7.8198 5.39066 9.23593 5.39066 10.9771C5.39066 12.7182 6.80678 14.1343 8.54792 14.1343C10.2891 14.1343 11.7052 12.7182 11.7052 10.9771Z"
      fill={color}
    />
    <path
      d="M2.29451 24.4482C2.29451 22.1064 4.19915 20.2017 6.54095 20.2017H10.5555C10.6752 20.2017 10.795 20.2075 10.9128 20.217C11.2455 20.2455 11.5743 20.1333 11.8157 19.9128C12.0514 19.6961 12.1807 19.3996 12.1807 19.0803C12.1807 18.4948 11.7321 17.993 11.1599 17.9379C10.9603 17.9189 10.7589 17.9094 10.5536 17.9094H6.53905C2.93513 17.9075 0 20.8423 0 24.4484V24.9198H2.29426L2.29451 24.4482Z"
      fill={color}
    />
    <path
      d="M12.5894 24.9197H14.8836V22.0951C14.8836 19.4473 17.0372 17.2936 19.6851 17.2936H24.1121C26.7599 17.2936 28.9136 19.4473 28.9136 22.0951V24.9197H31.2078V22.0951C31.2078 19.7001 30.0046 17.4818 27.9916 16.1609C26.834 15.4006 25.4921 14.9995 24.1139 14.9995H19.6869C17.4953 14.9995 15.4595 15.9974 14.1007 17.7367C13.1142 18.9988 12.5933 20.5062 12.5933 22.0952L12.5894 24.9197Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.7539 7.24219C28.7539 11.023 25.6783 14.0985 21.8976 14.0985C18.1168 14.0985 15.0413 11.021 15.0413 7.24219C15.0413 3.46139 18.1168 0.38588 21.8976 0.38588C25.6784 0.38588 28.7539 3.46149 28.7539 7.24219ZM26.4614 7.24215C26.4614 4.72545 24.4143 2.67829 21.8976 2.67829C19.3809 2.67829 17.3337 4.72545 17.3337 7.24215C17.3337 9.75884 19.3809 11.806 21.8976 11.806C24.4143 11.806 26.4614 9.75884 26.4614 7.24215Z"
      fill={color}
    />
  </svg>
)

export const HomeStudyIcon = ({ color = '#182358', ...rest }) => (
  <svg
    {...rest}
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    fill="none"
  >
    <path
      d="M3.67 3v-.73c0-.98 1.47-.98 1.47 0V3h2.57v-.73c0-.98 1.47-.98 1.47 0V3h2.57v-.73c0-.98 1.47-.98 1.47 0V3h1.46c1.22 0 2.2.99 2.2 2.2v16.16a2.2 2.2 0 01-2.2 2.2H2.21A2.2 2.2 0 010 21.36V5.2C0 3.98.99 3 2.2 3zM21.3 1.53c-.4 0-.73.33-.73.74v17.62c0 .11.03.22.08.33l1.47 2.93a.73.73 0 001.31 0l1.47-2.93c.05-.1.08-.22.08-.33V2.27c0-.41-.33-.74-.74-.74zm2.2 18.18l-.73 1.47-.73-1.47v-.92h1.47zm0-2.4V5.95h-1.46v11.38zm0-12.84h-1.46V3h1.47zM1.48 21.36V8.87h13.95v12.49c0 .4-.33.73-.74.73H2.21a.74.74 0 01-.74-.73zm2.2-16.9H2.21c-.41 0-.74.34-.74.74v2.2h13.95V5.2c0-.4-.33-.73-.74-.73h-1.46v.73c0 .98-1.47.98-1.47 0v-.73H9.18v.73c0 .98-1.47.98-1.47 0v-.73H5.14v.73c0 .98-1.47.98-1.47 0zm8.81 6.62H4.41c-.98 0-.98 1.46 0 1.46h8.07c.98 0 .98-1.46 0-1.46zm-8.07 3.67h8.07c.98 0 .98 1.47 0 1.47H4.41c-.98 0-.98-1.47 0-1.47zm4.4 3.67h-4.4c-.98 0-.98 1.47 0 1.47h4.4c.98 0 .98-1.47 0-1.47z"
      clipRule="evenodd"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
)

export const SettingsIcon = ({ color = '#182358', ...rest }) => (
  <svg
    {...rest}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.81241 19.874C2.08878 19.874 1.39543 19.586 0.885659 19.0733L0.885509 19.0732C0.369884 18.5644 0.079834 17.8701 0.079834 17.1455C0.079834 16.4218 0.369884 15.7275 0.885509 15.2187L6.89626 9.24022L2.94801 5.29197L2.57301 5.65622C2.44703 5.78904 2.26052 5.8447 2.08278 5.80173C1.90896 5.75681 1.76833 5.6279 1.70778 5.45798H1.70876L0.666761 2.33298C0.604261 2.14646 0.653088 1.94138 0.791761 1.80173L1.83278 0.760709C1.97438 0.61813 2.18533 0.569304 2.37478 0.635709V0.634732L5.49978 1.67673C5.66872 1.72946 5.79567 1.8691 5.83278 2.04196C5.87575 2.21773 5.82497 2.4023 5.69802 2.53121L5.29177 2.94821L8.41677 6.13571C8.36209 4.98628 8.67167 3.84861 9.30154 2.88571C9.78104 2.10446 10.4373 1.44723 11.2185 0.968707C12.658 0.0126569 14.4715 -0.185593 16.0828 0.437457C16.2488 0.499957 16.3738 0.640582 16.4168 0.812457C16.447 0.989207 16.3933 1.17085 16.2703 1.30171V1.30268L13.6248 3.94818V6.33296H16.0105L18.5935 3.68746C18.7244 3.56441 18.906 3.5107 19.0828 3.54195C19.2547 3.5849 19.3953 3.70894 19.4578 3.87495C20.0808 5.4862 19.8826 7.30073 18.9265 8.7392C18.448 9.52045 17.7908 10.1777 17.0105 10.6562C16.4558 11.0068 15.8465 11.2646 15.2078 11.417H15.2088L19.0105 15.2187C19.7888 15.999 20.0213 17.1709 19.5994 18.1895C19.1776 19.208 18.1854 19.873 17.0829 19.875C16.3593 19.8789 15.6639 19.5899 15.1561 19.0733H15.1552L9.94716 13.8653L4.73916 19.0733C4.22941 19.586 3.53603 19.874 2.81241 19.874ZM15.9482 18.3438C16.6161 18.9805 17.665 18.9805 18.3329 18.3438C19.0107 17.6983 19.038 16.628 18.3954 15.9483L13.9687 11.5313C13.498 11.5117 13.0331 11.4307 12.5829 11.292L10.7402 13.1358L15.9482 18.3438ZM3.31241 4.1455C3.21475 4.04687 3.08194 3.99218 2.94228 3.99218C2.80361 3.99218 2.67081 4.04687 2.57313 4.1455L2.39638 4.32226L1.71865 2.30176L2.30165 1.71876L4.32215 2.39551L4.13465 2.58301H4.13563C3.93641 2.78613 3.93641 3.11036 4.13563 3.31251L8.41688 7.63576L7.63563 8.41701L3.31241 4.1455ZM9.63466 7.9375L1.61416 15.9483L1.61414 15.9375C1.26063 16.2471 1.05067 16.6894 1.03504 17.1592C1.01942 17.6289 1.19912 18.084 1.53114 18.416C1.86414 18.749 2.31922 18.9287 2.78894 18.9131C3.25867 18.8974 3.70104 18.6875 4.01062 18.333H4.00964L12.0204 10.3125C12.1639 10.1738 12.3749 10.1289 12.5624 10.1982C13.8739 10.71 15.3524 10.5469 16.5204 9.76074C17.1659 9.36524 17.7089 8.82226 18.1044 8.17676C18.7215 7.26074 18.9569 6.13966 18.7606 5.05176L16.5936 7.21876C16.4999 7.32033 16.3671 7.37697 16.2294 7.37501H13.1044C12.9657 7.37501 12.8338 7.32032 12.7362 7.22267C12.6385 7.12499 12.5829 6.99219 12.5829 6.85449V3.72949C12.5819 3.59083 12.6385 3.459 12.7391 3.36427L14.9061 1.19824C14.6522 1.14844 14.3944 1.12402 14.1356 1.125C13.2938 1.1377 12.4735 1.39063 11.7704 1.8545C11.1278 2.24318 10.5848 2.7793 10.1874 3.417C9.40127 4.585 9.23719 6.06348 9.74989 7.375C9.82802 7.56835 9.7831 7.79004 9.63564 7.9375H9.63466Z"
      fill={color}
    />
  </svg>
)

export const CoursesIcon = ({ color = '#182358', ...rest }) => (
  <svg
    {...rest}
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5364 3.59375H5.46411C5.08326 3.59375 4.77563 3.90138 4.77563 4.28223C4.77563 4.66307 5.08326 4.9707 5.46411 4.9707H19.5364C19.9172 4.9707 20.2248 4.66307 20.2248 4.28223C20.2248 3.90138 19.9172 3.59375 19.5364 3.59375V3.59375Z"
      fill={color}
    />
    <path
      d="M19.5364 6.7285H5.46411C5.08326 6.7285 4.77563 7.03613 4.77563 7.41698C4.77563 7.79783 5.08326 8.10545 5.46411 8.10545H19.5364C19.9172 8.10545 20.2248 7.79783 20.2248 7.41698C20.2248 7.03613 19.9172 6.7285 19.5364 6.7285Z"
      fill={color}
    />
    <path
      d="M12.2511 9.86325H5.46411C5.08326 9.86325 4.77563 10.1709 4.77563 10.5517C4.77563 10.9326 5.08326 11.2402 5.46411 11.2402H12.2511C12.632 11.2402 12.9396 10.9326 12.9396 10.5517C12.9396 10.1709 12.632 9.86325 12.2511 9.86325Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.3349 2.163V13.4228L23.3351 13.4226C24.2335 13.6472 24.9024 14.4578 24.8976 15.4295C24.8976 16.5672 23.9698 17.4949 22.8321 17.4949H16.7824L19.9756 23.9061C20.1465 24.2479 20.0098 24.6581 19.668 24.829C19.3262 24.9999 18.9161 24.8632 18.7452 24.5214L17.7735 22.5682H7.22173L6.25493 24.5165C6.08403 24.8583 5.67388 24.9999 5.33208 24.829C4.99028 24.6581 4.84868 24.2479 5.01958 23.9061L8.19333 17.4901H2.16308C1.02538 17.4901 0.0976562 16.5624 0.0976562 15.4247C0.0976562 14.4579 0.766581 13.6474 1.66503 13.4228V2.163C1.66503 1.0253 2.59276 0.09758 3.73046 0.09758H21.2695C22.4072 0.09758 23.3349 1.0253 23.3349 2.163ZM3.73036 1.47453C3.34951 1.47453 3.04188 1.78216 3.04188 2.163L3.04183 13.3593H21.9531V2.163C21.9531 1.78216 21.6455 1.47453 21.2646 1.47453H3.73036ZM17.0896 21.1913H7.90013L9.73118 17.495H15.2487L17.0896 21.1913ZM2.16288 16.1133H22.8366H22.8368C23.2127 16.1133 23.5252 15.8056 23.5204 15.4248C23.5204 15.0439 23.2127 14.7363 22.8319 14.7363H2.16288C1.78203 14.7363 1.47441 15.0439 1.47441 15.4248C1.47441 15.8056 1.78203 16.1133 2.16288 16.1133Z"
      fill={color}
    />
  </svg>
)

export const CoursesIconSmall = ({ color = '#182358', ...rest }) => (
  <svg {...rest} xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <g fill={color} fillRule="nonzero">
      <path d="M12.54 2.26H3.46a.44.44 0 100 .88h9.08a.44.44 0 100-.88zM12.54 4.28H3.46a.44.44 0 100 .89h9.08a.44.44 0 100-.9zM7.84 6.3H3.46a.44.44 0 100 .89h4.38a.44.44 0 100-.89z" />
      <path d="M15 8.6V1.33C15 .6 14.4 0 13.65 0H2.34c-.73 0-1.33.6-1.33 1.33V8.6a1.33 1.33 0 00.32 2.62h3.9l-2.05 4.14a.44.44 0 00.2.6c.22.1.48.01.6-.2l.62-1.26h6.8l.63 1.26c.11.22.38.3.6.2.22-.11.3-.38.2-.6l-2.07-4.14h3.9A1.34 1.34 0 0015 8.6zM1.9 1.33c0-.24.2-.44.44-.44h11.32c.24 0 .44.2.44.44v7.23H1.9zm9.06 12.28H5.03l1.19-2.39h3.55zm3.71-3.28H1.33a.44.44 0 110-.89h13.34a.44.44 0 010 .9z" />
    </g>
  </svg>
)

export const SearchIcon = ({ color = '#182358', ...rest }) => (
  <svg
    {...rest}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0013 10.6168L15.6524 14.2686L15.6523 14.2686C15.8372 14.4536 15.9386 14.6991 15.9393 14.9619C15.9386 15.2234 15.8366 15.4689 15.6517 15.6538C15.4693 15.8369 15.2231 15.9396 14.961 15.9396C14.6995 15.9396 14.4539 15.8375 14.269 15.6526L10.6185 12.0028C9.48467 12.8452 8.11285 13.3019 6.68173 13.3019C4.91324 13.3019 3.25058 12.6131 2.00059 11.3624C0.749941 10.1118 0.0611572 8.44914 0.0611572 6.6813C0.0611572 4.91281 0.749941 3.25081 2.00059 2.00016C3.25055 0.75017 4.91259 0.0613861 6.68108 0.0613861C8.44891 0.0613861 10.1116 0.75017 11.3622 2.00016C13.6844 4.32147 13.9082 8.03135 12.0013 10.6168ZM9.97823 3.38403C9.09758 2.5033 7.92663 2.01796 6.68109 2.01796C5.43554 2.01796 4.26468 2.5033 3.38395 3.38403C2.50321 4.26468 2.01788 5.43562 2.01788 6.68117C2.01788 7.92672 2.50321 9.09758 3.38395 9.97832C4.2646 10.8591 5.43554 11.3444 6.68109 11.3444C7.92664 11.3444 9.0975 10.8591 9.97823 9.97832C10.8577 9.09946 11.3418 7.92798 11.3418 6.68117C11.3418 5.43383 10.8577 4.26286 9.97823 3.38403Z"
      fill={color}
    />
  </svg>
)

export const DownloadIcon = ({ color = '#182358', ...rest }) => (
  <svg
    {...rest}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.364 2.363A7.973 7.973 0 0 1 15.97 8a7.973 7.973 0 0 1-13.607 5.636 7.973 7.973 0 0 1 0-11.273zm1.025 10.248A6.52 6.52 0 0 0 14.522 8 6.52 6.52 0 0 0 8 1.478 6.52 6.52 0 0 0 1.478 8a6.52 6.52 0 0 0 1.91 4.611z"
      fill={color}
    />
    <path
      d="M11.109 8.21L8.725 10.6V3.652a.725.725 0 0 0-1.45 0v6.95L4.891 8.21a.728.728 0 0 0-1.029 1.03l3.623 3.622a.606.606 0 0 0 .218.138c.093.045.194.07.297.073a.902.902 0 0 0 .275-.051.846.846 0 0 0 .24-.16l3.622-3.623a.728.728 0 0 0-1.028-1.03z"
      fill={color}
    />
  </svg>
)

export const AddIcon = ({ color = '#182358', ...rest }) => (
  <svg
    {...rest}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.41888 13.5996C-0.666645 10.5141 -0.666645 5.50438 2.41888 2.41886C5.48574 -0.666667 10.5141 -0.666667 13.5996 2.41886C16.6852 5.50438 16.6852 10.5141 13.5996 13.5996C10.5141 16.6851 5.5044 16.6851 2.41888 13.5996ZM3.33336 12.6667C5.90478 15.2381 10.0953 15.2381 12.6667 12.6667C15.2381 10.0952 15.2381 5.90476 12.6667 3.33333C10.0953 0.761904 5.90478 0.761904 3.33336 3.33333C0.761927 5.90476 0.761927 10.0952 3.33336 12.6667Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00007 4.24781C7.63847 4.24781 7.35275 4.53352 7.35275 4.89512V7.37132H4.87656C4.51496 7.37132 4.22925 7.65703 4.22925 8.01863C4.22925 8.38023 4.51496 8.66594 4.87656 8.66594H7.35275V11.1421C7.35275 11.5037 7.63847 11.7894 8.00007 11.7894C8.1712 11.7894 8.34308 11.7136 8.45691 11.599C8.57149 11.4844 8.64738 11.3133 8.64738 11.1421V8.66594H11.1236C11.2947 8.66594 11.4666 8.59005 11.5804 8.47547C11.695 8.36088 11.7709 8.18975 11.7709 8.01863C11.7709 7.65703 11.4852 7.37132 11.1236 7.37132H8.64738V4.89512C8.64738 4.53352 8.36167 4.24781 8.00007 4.24781Z"
      fill={color}
    />
  </svg>
)

export const DownCaret = ({ color = '#182358', ...rest }) => (
  <svg
    {...rest}
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.57876 5.36156C4.69037 5.47317 4.84216 5.53623 5.00008 5.53623C5.15799 5.53623 5.30979 5.47318 5.42139 5.36156L9.73668 1.04628C9.96938 0.813577 9.96938 0.436348 9.73668 0.203648C9.50398 -0.0284947 9.12675 -0.0284947 8.89461 0.203648L5.00003 4.09822L1.10546 0.203648C0.873321 -0.0284947 0.496092 -0.0284947 0.263392 0.203648C0.0306922 0.436348 0.0306922 0.813577 0.263392 1.04628L4.57876 5.36156Z"
      fill={color}
    />
  </svg>
)

export const SaveIcon = ({ color = '#182358', ...rest }) => (
  <svg
    {...rest}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.0899658 10.0462C0.0899658 15.5078 4.53357 19.9508 9.99457 19.9508C15.4562 19.9508 19.8992 15.508 19.8992 10.0462C19.8992 4.5846 15.4564 0.141602 9.99457 0.141602C4.53377 0.141602 0.0899658 4.5844 0.0899658 10.0462ZM1.44917 10.0462C1.44917 5.3344 5.28277 1.5008 9.99457 1.5008C14.7064 1.5008 18.54 5.3344 18.54 10.0462C18.54 14.7588 14.7064 18.5916 9.99457 18.5916C5.28277 18.5916 1.44917 14.7586 1.44917 10.0462Z"
      fill={color}
    />
    <path
      d="M8.65082 13.3241C8.47036 13.3241 8.2977 13.2523 8.17036 13.1249L5.66176 10.6163C5.39692 10.3515 5.39692 9.921 5.66176 9.65538C5.92738 9.38976 6.35786 9.38976 6.6227 9.65538L8.6509 11.6828L13.3665 6.96718C13.6313 6.70234 14.0618 6.70234 14.3274 6.96718C14.5931 7.2328 14.5931 7.66328 14.3274 7.9289L9.13144 13.1249C9.0041 13.2522 8.83144 13.3241 8.65098 13.3241"
      fill={color}
    />
  </svg>
)

export const LeadsIcon = ({ color = '#182358', ...rest }) => (
  <svg {...rest} width="16" height="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.29 1.778c0 .676.384 1.272.944 1.572L7.26 6.411c-.049-.003-.1-.011-.15-.011-.748 0-1.415.34-1.872.867L2.967 5.272c.147-.241.233-.525.233-.828 0-.879-.72-1.6-1.6-1.6-.879 0-1.6.721-1.6 1.6 0 .88.721 1.6 1.6 1.6.318 0 .617-.093.867-.255l2.378 2.078a2.457 2.457 0 00.278 2.505L3.056 12.44a1.933 1.933 0 00-1.1-.35C.88 12.089 0 12.969 0 14.044 0 15.12.88 16 1.956 16s1.956-.88 1.956-1.956c0-.411-.131-.79-.35-1.105l2.06-2.061c.417.313.931.5 1.49.5.506 0 .978-.15 1.372-.411l.966 1.089a1.76 1.76 0 00-.383 1.1c0 .977.8 1.777 1.778 1.777s1.778-.8 1.778-1.778c0-.977-.8-1.777-1.778-1.777-.306 0-.592.079-.845.216l-.988-1.105a2.483 2.483 0 00.5-2.256l3.9-1.2c.257.37.685.611 1.166.611.781 0 1.422-.64 1.422-1.422 0-.781-.64-1.422-1.422-1.422a1.428 1.428 0 00-1.416 1.567l-3.94 1.21a2.5 2.5 0 00-1.26-1.021l.955-3.006a1.783 1.783 0 001.928-1.772C10.845.8 10.045 0 9.067 0S7.29.8 7.29 1.778z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
)

export const CloseIcon = ({ color = '#182358', ...rest }) => (
  <svg
    {...rest}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.03711 14.1222L14.2971 4.86218L15.0952 5.66023L5.83515 14.9202L5.03711 14.1222Z"
      fill={color}
    />
    <path
      d="M5.03711 5.66023L5.83515 4.86218L15.0952 14.1222L14.2971 14.9202L5.03711 5.66023Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.05376 16.906C4.91354 18.7668 7.43634 19.8118 10.0673 19.8118L10.0675 19.8121C12.6993 19.8187 15.2254 18.7729 17.0811 16.9063C19.5592 14.3953 20.5168 10.7561 19.597 7.35055C18.6763 3.94496 16.015 1.28372 12.6095 0.363027C9.20386 -0.556973 5.56472 0.400877 3.05376 2.87894C1.19298 4.73873 0.147949 7.26152 0.147949 9.89249C0.147949 12.5235 1.19305 15.0462 3.05376 16.906ZM3.84752 3.67787C5.49737 2.02801 7.73429 1.10311 10.0671 1.10475C12.3992 1.09895 14.6363 2.02551 16.2811 3.67873C18.503 5.89808 19.3708 9.13486 18.5585 12.169C17.7469 15.2024 15.3778 17.5722 12.3445 18.3863C9.31118 19.2002 6.0744 18.3333 3.85333 16.1131C2.20178 14.4658 1.27352 12.2297 1.27268 9.89679C1.27118 7.56389 2.19765 5.3269 3.84752 3.67787ZM10.0671 1.10475C10.0672 1.10475 10.0672 1.10475 10.0673 1.10475H10.0671C10.0671 1.10475 10.0671 1.10475 10.0671 1.10475Z"
      fill={color}
    />
  </svg>
)

export const TableIcon = ({ color = '#182358', ...rest }) => (
  <svg {...rest} xmlns="http://www.w3.org/2000/svg" width="25" height="25">
    <path
      d="M20.51 2.59H4.46a1.9 1.9 0 00-1.88 1.89v16.05a1.9 1.9 0 001.9 1.88h16.04a1.9 1.9 0 001.9-1.9V4.49a1.9 1.9 0 00-1.9-1.9zm0 7.55h-8.5V4.48h8.5zM4.46 4.48h5.67v16.05H4.46zm7.56 16.05v-8.5h8.5v8.5z"
      fill={color}
    />
  </svg>
)

export const TableIconSmall = ({ color = '#182358', ...rest }) => (
  <svg {...rest} width="16" height="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.4.1H1.6C.77.1.1.76.1 1.6v12.8c0 .83.67 1.5 1.5 1.5h12.8c.83 0 1.5-.67 1.5-1.5V1.6c0-.83-.67-1.5-1.5-1.5zm0 6.02H7.62V1.6h6.78v4.52zM1.6 1.6h4.52v12.8H1.6V1.6zm6.02 12.8V7.62h6.78v6.78H7.62z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
)

export const PrintIcon = ({ color = '#132358', ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25">
    <path
      d="M21.15 9.86l.03-.38V3.15c0-1.03-.83-1.85-1.84-1.86H5.64c-1.02 0-1.85.83-1.86 1.86v6.33c0 .13.02.26.05.4a2.56 2.56 0 00-2.5 2.6v6.1a2.6 2.6 0 002.6 2.59h.6c.38 0 .75-.1 1.1-.25v1.33c-.03.42.12.82.41 1.1.45.34 1 .44 1.55.3a5.28 5.28 0 01.62-.04h8.54a5.28 5.28 0 01.62.04l.56.04c.35.02.7-.1.99-.33.29-.3.44-.69.42-1.11v-1.37c.34.17.71.25 1.1.25h.6a2.58 2.58 0 002.62-2.59v-6.07a2.58 2.58 0 00-2.53-2.6zM5.28 3.14c0-.2.17-.37.38-.37h13.67a.37.37 0 01.36.37v6.33c0 .2-.15.38-.36.38H5.66a.38.38 0 01-.38-.37V3.15zm12.58 19h-.33c-.24 0-.49-.05-.75-.05H8.21c-.27 0-.53 0-.74.05h-.34v-3.61c0-.6.48-1.08 1.09-1.08h8.55a1.1 1.1 0 011.1 1.08zm4.33-3.61a1.1 1.1 0 01-1.1 1.1h-.6a1.1 1.1 0 01-1.1-1.1 2.58 2.58 0 00-2.58-2.57H8.22a2.58 2.58 0 00-2.58 2.57 1.1 1.1 0 01-1.1 1.1h-.6a1.1 1.1 0 01-1.1-1.1v-6.07c0-.6.49-1.1 1.1-1.1h17.14a1.1 1.1 0 011.1 1.1z"
      fill={color}
    />
  </svg>
)

export const PrintIconSmall = ({ color = '#182358', ...rest }) => (
  <svg {...rest} width="17" height="17" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.01 6.5l.03-.29v-4.8c0-.78-.63-1.4-1.4-1.41H3.26c-.78 0-1.41.63-1.42 1.41v4.8c0 .1.02.2.04.3-1.06.03-1.9.9-1.89 1.97v4.63c0 1.08.88 1.95 1.96 1.96h.46c.29 0 .57-.07.83-.19v1.01c-.02.32.1.62.32.84.34.25.76.33 1.17.22a4 4 0 01.47-.03h6.48a4 4 0 01.47.03l.42.03c.27.02.54-.07.75-.25.22-.22.34-.52.32-.84v-1.04c.26.13.54.19.83.19h.46a1.96 1.96 0 001.99-1.96v-4.6A1.96 1.96 0 0015 6.5zM2.98 1.4c0-.15.13-.28.29-.28h10.36a.28.28 0 01.28.28v4.8c0 .16-.12.29-.28.29H3.27a.29.29 0 01-.29-.28v-4.8zm9.54 14.41h-.25c-.18 0-.37-.04-.57-.04H5.2c-.2 0-.4 0-.56.04h-.26v-2.74c0-.45.37-.82.83-.82h6.48a.83.83 0 01.83.82v2.74zm3.28-2.74a.83.83 0 01-.83.83h-.46a.83.83 0 01-.83-.83c0-1.08-.88-1.95-1.96-1.95H5.21c-1.08 0-1.96.87-1.96 1.95a.83.83 0 01-.83.83h-.46a.83.83 0 01-.83-.83v-4.6c0-.46.37-.83.83-.83h13a.83.83 0 01.84.83v4.6z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
)

export const EditIcon = ({ color = '#182358', ...rest }) => (
  <svg {...rest} width="16" height="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.74 14.36h-.1l-.09.02.2-.02zm-9.49 0l.2.02-.09-.01-.11-.01zm9.98-.16l-.08.03-.1.04.18-.07zm-10.47 0l.18.07-.09-.04-.09-.03zm-.44-.3l.15.12-.09-.07-.06-.04zm11.7-.36l-.08.08-.04.07.06-.08.05-.07zm-12.04 0l.12.15-.06-.07-.06-.08zm12.28-.47l-.04.07-.03.1.07-.17zm-12.52 0l.07.17-.03-.08-.04-.1zm12.63-.6V7.2c0-.4.34-.7.72-.73.4-.02.73.35.73.73v5.15c0 .59-.15 1.16-.42 1.67a3.5 3.5 0 01-3.05 1.8H3.64a3.5 3.5 0 01-3.47-3.47V3.65A3.49 3.49 0 013.64.18h5.15c.41 0 .71.33.73.72.02.4-.35.73-.73.73H4.01c-.25 0-.5 0-.76.03l.11-.01-.15.02-.23.07-.14.05-.07.03-.3.18-.07.05-.1.09c-.07.05-.12.1-.17.16l-.08.1-.1.12-.11.21-.07.14-.04.12-.07.23-.03.16v.26 7.97c0 .38-.03.77.02 1.14l-.01-.1.02.14.07.23.05.14.03.07c.05.1.11.21.18.31l.05.08.09.1.16.16.1.07.12.1.21.12.13.06.13.05.23.06.15.03h.08l.19.01h7.97c.38 0 .77.03 1.14-.02h-.1l.14-.02.23-.06.14-.05.07-.04c.1-.05.21-.11.31-.18l.06-.04-.06.05.15-.11-.08.06.1-.1.17-.16.07-.09.1-.13.12-.2.06-.15.05-.12.06-.23.03-.13-.01.1.02-.2-.01.1zm-12.75.1l.03.18-.01-.1-.02-.09zM12.98.24c.22-.08.44-.07.66-.04.25.04.49.2.67.37l1.11 1.11c.17.17.3.38.36.61.12.45-.02.92-.34 1.26h-.01l-.57.58-.56.56-2.15 2.14-1.04 1.05-1.05 1.05-.98.98a.81.81 0 01-.55.22h-.2l-.7.05-1.12.07c-.38.02-.74-.35-.73-.73l.01-.13.08-1.74v-.2a.8.8 0 01.23-.54l.17-.16 3.46-3.47 1.33-1.33 1-.99.4-.4c.15-.15.32-.25.52-.32zm-5.7 8.5l-.51.04-.26.01.73.73.03-.77zm1.28-.07l-.32.02-.18.18-.01.01.51-.21zm4.82-6.98l-.29.28-.37.38-1.59 1.59L9.3 5.79 7.3 7.76l-.03.86v.14l.39-.03.57-.03.2-.2.4-.4 2.5-2.5.92-.92 1.52-1.52.63-.63-.1.1-.34-.33-.32-.33-.15-.15-.12-.12zM7.33 7.45l-.21.51.2-.2V7.7v-.25zm7.17-5l-.06.05-.04.05.01-.02.02-.05-.03.06h-.01v.03l-.02.01v.11l-.05-.04-.04.06a.73.73 0 00.13.85c.26.23.67.28.95.07l.07-.06v-.01c.28-.27.3-.77 0-1.03a.74.74 0 00-.93-.07zm-12.85.81l-.02.1v.09-.07l.02-.12zm.16-.49l-.07.18.03-.08.04-.1zm12.59-.06l.02.02.05.08-.06-.07-.01-.03zm0 .01l.01.02.01.03-.02-.05zm-.01 0v.03-.04zm0-.01v.01-.01zm0-.03l.01.03-.01-.01v-.02zm-.02 0l.01.02h-.01v-.02zm0 .01v.02-.02zm.01 0v.02-.02zm0-.03v.03-.03zm-.02 0l.01.02-.01-.02zm.02-.02v.04-.04zm0 0v.02-.01zm-.02 0v.02-.02zm.01-.02v.02-.02zm.01-.03v.05-.05zm-.02.02v.02-.02zm.01 0zm-.01 0zm.01-.02l-.01.02.01-.02zm.01-.01v.02-.02zm.02-.03v.02l-.02.02v-.02l.02-.02zm-.03.03zm.02-.02v.02-.01zm-.08.07l.01.02.02-.04.01-.01.02-.02.01-.02-.07.07zm.09-.09v.01l-.01.01.01-.02zm0-.02l-.01.03v-.03zm.01 0l-.01.02.01-.01zm.06-.05l-.06.06.03-.03.03-.03zM2.1 2.33l-.12.15.07-.08.05-.07zm.37-.34l-.15.12.08-.06.07-.06zm.47-.24l-.18.07.08-.03.1-.04zm10.41-.11h-.02l.02.01-.02-.01h-.01l.04.03.02.03.06-.06h-.02l-.02.01.02.01h-.02l-.02-.01-.03-.01zm-9.9 0c-.07 0-.14 0-.2.02l.11-.01.08-.02zm9.95.01zm-.03 0h-.02.02zm.03-.01h-.02l.02.01.02-.01h-.02zm-.03 0h.02-.02zm-.05 0h-.02.02zm.12 0zm-.14-.02l.02.02v-.01h-.02zm.15 0l-.03.02h.02l.01-.02zm-.03.02zm-.09 0zm.07 0zm-.05 0h.01zm-.03-.01h.03-.03zm.11 0h-.02.02zm-.01 0h-.04.04zm-.09 0h.05-.05zm.12 0h-.02.01zm-.15 0h.01zm.15-.02h-.01l-.02.02h.02l.01-.02zm-.16 0l.02.01h.02l-.04-.01zm-.04 0l.05.01h-.05zm.24 0l-.04.01h.04zm-.2 0v.01h.01-.01zm.17 0l-.01.01h.01zm.06-.03l-.05.02v.01l.05-.03zm.02-.04l-.09.07h.02l.07-.07zm-.3.05l.05.02h-.02l-.03-.02zm-.04-.05l.07.06h.02-.01l-.08-.06z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
)

export const UploadIcon = ({ color = '#182358', ...rest }) => (
  <svg {...rest} width="16" height="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.97 0a7.97 7.97 0 110 15.95A7.97 7.97 0 017.97 0zm0 1.45a6.52 6.52 0 100 13.04 6.52 6.52 0 000-13.04zm0 1.45c.1 0 .2.03.3.07a.6.6 0 01.22.14l3.62 3.62a.73.73 0 01-1.03 1.03L8.7 5.37v6.95a.73.73 0 01-1.45 0V5.37l-2.39 2.4a.73.73 0 01-1.03-1.04l3.63-3.62a.85.85 0 01.24-.16.9.9 0 01.27-.05z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
)

export const LoadingIcon = props => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    style={{ margin: 'auto', background: '0 0', width: '50px', height: '50px' }}
    width="200"
    height="200"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
    display="block"
  >
    <circle
      cx="50"
      cy="50"
      fill="none"
      stroke="#558dab"
      strokeWidth="6"
      r="35"
      strokeDasharray="164.93361431346415 56.97787143782138"
      transform="rotate(265.88 50 50)"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        repeatCount="indefinite"
        dur="1s"
        values="0 50 50;360 50 50"
        keyTimes="0;1"
      />
    </circle>
  </svg>
)
